import type { FaireThemeEntity } from "../../entity_types/theme";

export const impulse_gifts_candles_cards_candy: FaireThemeEntity = {
  token: "impulse-gifts-candles-cards-candy",
  type: "theme",
  name: "Impulse Gifts: Candles, Cards & Candy",
  description: "",
  teaser: "",
  detail: "",
  bgColor: "#D4EEF0",
  exactProducts: true,
  retailerToken: "r_eer7xgiweo",
  productTokens: [
    "p_qhjqjgtp9t",
    "p_zsvbcaz482",
    "p_9nfkz8ppe6",
    "p_mgxp53zj6c",
    "p_trf2xkf4pe",
    "p_d4qtcdysde",
    "p_jmp2knjk8m",
    "p_3v2kvcu3md",
    "p_pkg48vcrsd",
    "p_5c4pm1hv",
    "p_9dbrkvv2d4",
    "p_f4hsggwwt3",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
